const urlServers = {
	urlmaster: {
		produccion: 'https://marketeaaccounts.com/',
		test: 'https://m.marketea.app/',
		dev: 'http://127.0.0.1:8000/'
	},
	urlReseller: {
		produccion: 'https://marketeaaccounts.com/api/',
		test: 'https://m.marketea.app/api/',
		dev: 'https://m.marketea.app/api/'
	},
	urlbilling: {
		produccion: 'https://marketeabilling.com/',
		test: 'https://marketeabilling2.com/',
		dev: 'http://127.0.0.1:8050/'
	},
	urlweb: {
		produccion: 'https://marketea.com/',
		test: 'https://marketea.com/',
		dev: 'https://marketea.com/'
	},
	urlbSite: {
		produccion: 'https://bsite.me/',
		test: 'https://bsite.marketea.app/',
		dev: 'http://bsite.local/'
	}
};
export default urlServers;
